import React, { useState, useEffect } from "react";
import ListaToggleButton from "./fields/ListaToggleButton";
import SwitchConInput from "./fields/SwitchConInput";
import SwitchConNInput from "./fields/SwitchConNInput";
const Installazione = (props) => {
  const [installazione, setInstallazione] = useState(
    props.preventivo.installazione || {
      title: "Installazione",
      descr: "E' compreso nel preventivo la fornitura dei materiali",

      // montaggioSanitari
      montaggioSanitari: {
        tipologia: "ListaToggleButton",
        titolo: "Montaggio sanitari",
        descrizione: `Preparazione delle connessioni idrauliche, Montaggio dei sanitari, Fissaggio e livellamento, Connessioni idrauliche ed eventuali elettriche, Guarnizioni e sigillanti, Verifica e test`,
        valore: [
          { nome: "Wc", num: 0, prezzo: 40 },
          { nome: "Bidet", num: 0, prezzo: 40 },
          { nome: "Lavandino", num: 0, prezzo: 40 },
          { nome: "Doccia", num: 0, prezzo: 150 },
          { nome: "Vasca", num: 0, prezzo: 250 },
          { nome: "Lavatoio", num: 0, prezzo: 60 },
        ],
        ancheInput: true,
        descrizioneInput: "N. altri sanitari non elencati",
        quantitaAncheInput: 0,
        prezzoAncheInput: 50,
        descQuantita: "num",
        prezzoFinale: 0,
      },
      // montaggioRadiatori
      montaggioRadiatori: {
        tipologia: "SwitchConInput",
        titolo: "Montaggio radiatori",
        descrizione: `Preparazione del sito, Montaggio supporti, Connessioni alle tubazioni, Installazione delle valvole, serraggio e fissaggio, riempimento e purga del sistema`,
        valore: false,
        descrizioneQuantita: "Numero radiatori",
        descQuantita: "u",
        quantita: 0,
        prezzo: 50,
      },
  /// inserire montaggio split senza materiali 350 euro cadauno 
    }
  );

  useEffect(() => {
    props.onChange(installazione);
  }, [installazione]);

  {
    /* divisore*/
  }
  const divider = (
    <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
  );

  return (
    <>
      <div className="surface-ground px-1 py-1 md:px-4 md:py-4">
        <div className="text-900 font-medium text-900 text-xl mb-2">
          {installazione.title}
        </div>
        <p className="m-0 mb-2 p-0 text-600 line-height-3 mr-3">
          {installazione.descr}
        </p>
        <div className="surface-card p-4 shadow-2 border-round">
          <div className="grid formgrid p-fluid">
            {Object.keys(installazione).map((key) => (
              <React.Fragment key={key}>
                {installazione[key].tipologia === "SwitchConInput" && (
                  <>
                    <SwitchConInput
                      field={installazione[key]}
                      onChange={(data) => {
                        setInstallazione({ ...installazione, [key]: data });
                      }}
                    />
                    {divider}
                  </>
                )}
                {installazione[key].tipologia === "SwitchConNInput" && (
                  <>
                    <SwitchConNInput
                      field={installazione[key]}
                      onChange={(data) => {
                        setInstallazione({ ...installazione, [key]: data });
                      }}
                    />
                    {divider}
                  </>
                )}
                {installazione[key].tipologia === "ListaToggleButton" && (
                  <>
                    <ListaToggleButton
                      field={installazione[key]}
                      onChange={(data) => {
                        setInstallazione({ ...installazione, [key]: data });
                      }}
                    />
                    {divider}
                  </>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
export default Installazione;
